Date.prototype.toStringTime = function () {
    return '' + (this.getHours() > 9 ? '' : '0') + this.getHours() + ':' + (this.getMinutes() > 9 ? '' : '0') + (this.getMinutes());
};
